import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useSecurityTypeTranslation } from '@dealstack/frontend/shared/translationControllers/useCommonTranslationsController.ts';
import { GetLoansRes, LoanDefinitionType } from '@dealstack/shared/lib/generated';
import { formatNumberToUI } from '@dealstack/shared/lib/format/number.ts';
import { Badge, Divider, Flex, Text } from '@mantine/core';

interface Props {
	loans: GetLoansRes[];
	tInvestor: ReturnType<typeof useTranslationInvestor>;
}

export const InvestorLoanDetailPanel = ({ loans, tInvestor }: Props) => {
	const getLoanDefinitionTypeTranslation = useSecurityTypeTranslation();

	return (
		<Flex direction="column" bg="grape.0" style={{ flex: 1 }}>
			{loans.map((loan, idx) => (
				<div key={loan.loanDefinitionId}>
					<div
						style={{
							display: 'grid',
							gridTemplateColumns:
								'minmax(160px, 1fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(160px, 0.5fr)',
							padding: '0.5rem 0.75rem',
						}}
					>
						<Flex direction="column">
							<Text size="B6Medium" fw={600}>
								{tInvestor('valuations.holding_table.loan_rows.funding_type')}
							</Text>
							<Badge color="pink.9" bg="pink.2" mt="0.5rem">
								<Text size="B6Medium">
									{getLoanDefinitionTypeTranslation(loan.type)}
								</Text>
							</Badge>
						</Flex>

						<Flex direction="column">
							<Text size="B6Medium" fw={600}>
								{tInvestor('valuations.holding_table.loan_rows.name')}
							</Text>
							<Text mt="0.25rem" size="B6Medium">
								{loan.name}
							</Text>
						</Flex>

						<Flex direction="column">
							<Text size="B6Medium" fw={600}>
								{tInvestor('valuations.holding_table.loan_rows.funder')}
							</Text>
							<Text mt="0.25rem" size="B6Medium">
								{loan.funder.replace(LoanDefinitionType.MANAGEMENT_LOAN, '')}
							</Text>
						</Flex>

						<Flex direction="column">
							<Text ta="right" size="B6Medium" fw={600}>
								{tInvestor('valuations.holding_table.loan_rows.loan_amount')}
							</Text>
							<Text ta="right" mt="0.25rem" size="B6Medium">
								{formatNumberToUI(loan.totalValue, loan.currency)}
							</Text>
						</Flex>
					</div>
					{idx < loans.length - 1 && <Divider c="grape.2" />}
				</div>
			))}
		</Flex>
	);
};
